// extracted by mini-css-extract-plugin
export default {"contactus":"index_contactus_p8sUQ","phoneNum":"index_phoneNum_3YaCq","personEmail":"index_personEmail_2hdd7"};